import React from "react";
import { render } from "react-dom";
import MobileApp from "./MobileApp";
import WebApp from "./WebApp";
import "./index.css";
import { debounced } from "./lib/util";
import ons from "onsenui";



// Initialize Mobile app
const mobileRootElement = document.getElementById("testdrugs-app-mobile");
if (mobileRootElement) {
  // Fix tabbar size on window size change
  const fixTabbarSizes = () => {
    if (document.querySelector("ons-tabbar") != null) {
      document.querySelector("ons-tabbar")._show();
    }
  };
  const debouncedFixTabbarSizes = debounced(200, fixTabbarSizes);
  ons.orientation.on("change", debouncedFixTabbarSizes);

  ons.ready(() => render(<MobileApp />, mobileRootElement));
}

// Initialize Web app
const webRootElement = document.getElementById("testdrugs-app-web");
if (webRootElement) {
  if (!webRootElement.getAttribute("data-testdrugs-loaded")) {
    document.getElementsByTagName("body")[0].style["overflow-y"] = "visible";
    webRootElement.setAttribute("data-testdrugs-loaded", "true");
    render(<WebApp />, webRootElement);
  }
}


// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
// serviceWorker.unregister();
